import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import { lifecycle } from 'recompose'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Table from '../../../form/component/Table'
import taskListColumnList from './tasklist-column-list'

const TaskList = ({ taskList, tableSetting, changeTableSetting, navigateToTaskDetail, canSeeCustomerNames, isTablet, currentUserId, toggleColumnVisibility}) => {
    return (
        <ContentBox title="Worklist">
            <Row>
                <Column size={12}>
                    <Table
                        columnList={taskListColumnList(canSeeCustomerNames, isTablet, currentUserId)}
                        rowList={taskList}
                        changeTableSetting={changeTableSetting}
                        tableSetting={tableSetting}
                        idProperty="id"
                        onRowClick={(task) => {
                            navigateToTaskDetail(task.id)
                        }}
                        toggleColumnVisibility={toggleColumnVisibility}
                    />
                </Column>
            </Row>
        </ContentBox>
    )
}


TaskList.propTypes = {
    taskList: PropTypes.array.isRequired,
    tableSetting: PropTypes.object.isRequired,
    changeTableSetting: PropTypes.func.isRequired,
    navigateToTaskDetail: PropTypes.func.isRequired,
    canSeeCustomerNames: PropTypes.bool.isRequired,
    currentUserId: PropTypes.string.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.initialColumnsVisibility()
        this.props.findTaskList()
    },
})(withLayout(TaskList))



// WEBPACK FOOTER //
// ./src/modules/process/component/task-list/TaskList.js